import "regenerator-runtime/runtime.js";
import {AnnotationManager} from "./AnnotationManager";
import {DocumentManager} from "./DocumentManager";
import {PDFButton, PDFDocument, PDFPage} from "PDFLib/api";
import {ToastService} from "shared/core/services/ToastService";

export class PageManager{

    public Annotations:AnnotationManager[];
    public PageLib:PDFPage;
    public PageObject:any;

    constructor(public DocumentManager:DocumentManager,public Index:number,public Document:PDFDocument) {
        this.PageLib=this.Document.getPage(Index);

    }




    public async InitializePage()
    {
        this.Annotations=[];
        this.PageObject=await this.DocumentManager.DocumentObject.getPage(this.Index+1);

        let annotations= await this.PageObject.getAnnotations();
        for(let currentAnnotation of annotations)
        {
            let annotation=new AnnotationManager(this,currentAnnotation);
            if(annotation.Field!=null)
                this.Annotations.push(annotation);
        }

        return this;
    }

    async LoadInCanvas(canvas: HTMLCanvasElement) {

        let scale = 1.4;
        let viewport = this.PageObject.getViewport({ scale: scale });

        var context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        var renderContext = {
            canvasContext: context,
            viewport: viewport
        };
        return this.PageObject.render(renderContext).promise;
    }



    async AddField(fieldId: string,x:number,y:number,width:number,height:number) {
        let field=null;
        let nameToUse='CustomField_1';
        let index=1;
        let fields=this.Document.getForm().getFields();
        while(fields.find(x=>x.getName()==nameToUse)!=null)
        {
            index++;
            nameToUse='CustomField_'+index;
        }

        switch(fieldId)
        {
            case 'TextInput':
                field=this.Document.getForm().createTextField(nameToUse);
                if(height==0)
                    height=20;
                if(width==0)
                    width=200;
                break;
            case 'CheckBox':
                field=this.Document.getForm().createCheckBox(nameToUse);
                if(height==0)
                    height=10;
                if(width==0)
                    width=10;
                break;
            case 'Radio':
                field=this.Document.getForm().createRadioGroup(nameToUse);
                if(height==0)
                    height=10;
                if(width==0)
                    width=10;
                break;
            case 'DropDown':
                field=this.Document.getForm().createDropdown(nameToUse);
                if(height==0)
                    height=20;
                if(width==0)
                    width=200;
                break;
            case 'Signature':
                if(height==0)
                    height=100;
                if(width==0)
                    width=100;
                field=this.Document.getForm().createButton(nameToUse);
                break;

        }
        let cropBox=this.PageLib.getCropBox();

        if(fieldId=='Signature')
        {
            let tempImageURL=rnImporterVar.RootURL+'images/temporalImage.png';
            let image=null;
            try {
                image =await (await fetch(tempImageURL)).arrayBuffer();
            }catch (e) {
                ToastService.SendErrorMessage('Could not load sample image, please make sure you have internet access');
                return;
            }
            let png:any=await this.Document.embedPng(image);


            field.addToPage('',this.DocumentManager.SelectedPage.PageLib,{x:cropBox.x+x,y:cropBox.height+cropBox.y-height-y,height:height,width:width});
            (field as PDFButton).setImage(png);

        } else if(fieldId!='Radio')
            field.addToPage(this.DocumentManager.SelectedPage.PageLib,{x:cropBox.x+x,y:cropBox.height+cropBox.y-height-y,height:height,width:width});
        else
            field.addOptionToPage('Test',this.DocumentManager.SelectedPage.PageLib,{x:cropBox.x+x,y:cropBox.height+cropBox.y-height-y,height:height,width:width});
        this.DocumentManager.SelectedPDFField=null;
        await this.DocumentManager.RefreshDocument();

        this.DocumentManager.SetSelectedPDFField(this.DocumentManager.PDFFields.find(x=>x.GetFieldName()==nameToUse));
        this.DocumentManager.RefreshCanvas();

    }

    ConvertPixelToPoint(x:number,y:number):{x:number,y:number}
    {
        let viewPort=this.PageObject.getViewport({ scale: 1.4 });
        let point= viewPort.convertToPdfPoint(x,y);
        return {
            x:point[0],
            y:point[1]
        }
    }
}